import { Button, SxProps, Theme } from '@mui/material';
import React from 'react';
import { Flow } from '../types/flow';
import { useFlow } from '../hooks/useFlow';
import { ColorPalettes } from '../../../../../patient/src/features/reservation/constants/ColorPalettes';

interface Props {
  flow: Flow;
  title: string;
  sx?: SxProps<Theme>;
}

const defaultSx: SxProps<Theme> = { bgcolor: ColorPalettes.GRAY, color: ColorPalettes.WHITE };

function TransitionTopButton({ flow, title, sx = defaultSx }: Props) {
  const { setFlow } = useFlow();
  const handleClick = () => {
    setFlow(flow);
  };
  return (
    <Button
      className="flex items-center gap-x-2 mx-auto w-1/2 py-4 rounded-base font-medium text-2xl sm:text-2xl hover:bg-primary/80"
      sx={sx}
      onClick={handleClick}
    >
      {title}
    </Button>
  );
}

export default TransitionTopButton;
